module.exports = "<div class=col-sm-4> <div class=card> <img class=card-img-top src=http://worldwide-web.com/JeffreyBabad/Simpsons/Captain/captain.gif alt=\"Card image cap\"> <div class=card-body> <h5 class=card-title>${this.user.last_name}</h5> <p class=card-text>Text cards</p> <a href=${this.url} class=\"btn btn-primary\">Modifier</a> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./accounts/pro/static/js/models/StaffCard.html
// module id = 166
// module chunks = 0